/**
 * Module valuation-comparables defines comparable observations and market-data items
 * stored on valuations, including source links, retrieval dates, and monetary ranges.
 *
 * Shared comparable fields are defined in value-overview.ts. Comparison-method
 * calculations are defined in valuation-comparison.ts.
 */
import { z } from 'zod';
import { ComparableDataSchema, ComparablesDataEntrySchema, ComparablesSchema } from './value-overview';
import { ISODateSchema, UUIDSchema } from './common';
import { MonetaryValueSchema } from './money';
const ValuationComparablesDataEntrySchema = z.intersection(ComparablesDataEntrySchema, z.object({ copy_of_market_data_point_id: z.string().optional() }));
const ValuationComparableDataSchema = ComparableDataSchema.extend({
    entries: ValuationComparablesDataEntrySchema.array().optional(),
});
export const ValuationComparablesSchema = ComparablesSchema.extend({
    market_data: ValuationComparableDataSchema.array(),
});
const MonetaryRangeSchema = z.object({
    start: MonetaryValueSchema.optional(),
    end: MonetaryValueSchema.optional(),
});
export const MarketDataItemSchema = z.object({
    id: UUIDSchema,
    title: z.string(),
    retrieval_date: ISODateSchema,
    description: z.string(),
    tag_line: z.string().optional(),
    range: MonetaryRangeSchema.optional(),
    average_price_per_sqm: MonetaryValueSchema,
});
